import type { DetailedHTMLProps, HTMLAttributes } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { type Theme } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled, { type StyledComponent } from '@emotion/styled';

import { token } from '@atlaskit/tokens';

import { grid, dialogPageTakeoverWidth } from '../style-utils';
import type { SearchCSS } from '../theme';

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ArrowIconWrapper: StyledComponent<
	{
		theme?: Theme;
		as?: React.ElementType;
	} & SearchCSS,
	DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
	{}
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression
> = styled('div')<SearchCSS>`
	display: none;
	margin: 0 ${grid.px};
	height: ${grid.multiple(4).px};
	padding-bottom: ${grid.multiple(0.25).px};
	color: ${(props) => props.default.color};

	@media screen and (max-width: ${dialogPageTakeoverWidth}px) {
		display: flex;
		align-items: center;
	}

	:hover {
		border-radius: ${token('radius.full')};
		background-color: ${(props) => props.hover.backgroundColor};
		color: ${(props) => props.hover.color};
	}
`;
